import React from 'react';
import cx from 'classnames';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import Button from 'src/components/button/index';
import styles from './dataSourceDeleteView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
class DataSourceDeleteView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;
    this.localizedDeleteSlider = this.localizedContentSources.sliders.delete;
  }

  _handleDeleteClick() {
    if (this.props.onDelete) {
      this.props.onDelete();
    }
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <span className={styles.heading}>{this.localizedDeleteSlider.title}</span>

          <p className={styles.description}>
            {localizedStrings.formatString(this.localizedDeleteSlider.sub_text, {
              name: this.props.name,
              assetsCount: this.props.assets
            })}
          </p>

          <div className={styles.buttonTray}>
            <Button
              text={this.localizedCommonActions.confirm}
              variant="primary"
              className={styles.send}
              onClick={() => { this._handleDeleteClick() }}
              icon='paperflite-tick'
            >
            </Button>
            <Button
              text={this.localizedCommonActions.cancel}
              variant="secondary"
              className={styles.cancel}
              onClick={() => { this._handleCancelClick() }}
            >
            </Button>
          </div>
        </Row>
      </div>
    );
  }

}
export default DataSourceDeleteView;
